import { Business, Service } from "@turizi/shared";
import { getAttrValue } from "@/lib/models-utils";
import { useTranslation } from "react-i18next";
import { BUSINESSES_PATH, SERVICES_PATH } from "@/lib/navigation";
import { wrapInLink } from "@/lib/draw-utils";
import { Link } from "react-router-dom";
import { formatTime } from "@/lib/format-utils";


interface Props {
    service: Service;
    links?: boolean;
}

export default function DefaultTitle({
    service,
    links = false,
}: Props) {
    const { t } = useTranslation();
    const start_time = getAttrValue(service, 'start_time');
    const end_time = getAttrValue(service, 'end_time');
    const isNightly = start_time > "19:00";

    return (
        <div className="space-y-1 w-full">
            {wrapInLink(
                <div className="w-full">
                    <div className="font-semibold">
                        {service?.name}
                    </div>

                    {/* Service Features */}
                    <div className="flex flex-wrap gap-2 mt-1">
                        {getAttrValue(service, 'start_time') && (
                            <div
                                className={`
                            custom-badge 
                            ${isNightly ? 'bg-blue-100 text-blue-800' : 'bg-yellow-100 text-yellow-800'}
                        `}
                            >
                                <span>
                                    {formatTime(start_time)}
                                </span>
                                <span className="text-gray-400">
                                    -
                                </span>
                                <span>
                                    {formatTime(end_time)}
                                </span>
                            </div>
                        )}
                        <div className="text-slate-500 font-light bg-gray-100 rounded-full px-2 py-0.5">
                            #{service.id}
                        </div>
                    </div>
                </div>,
                links ? `${SERVICES_PATH}/${service.id}` : null)
            }
        </div>
    )
}